export default function ShareIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden focusable="false">
      <path d="M15 8.2L9.3 11.3m5.7 4.5L9.3 12.7" />
      <circle cx="17.2" cy="7" r="2.2" />
      <circle cx="7" cy="12" r="2.2" />
      <circle cx="17.2" cy="17" r="2.2" />
    </svg>
  )
}
